module.exports = __webpack_public_path__ + "img/union.67fc3426.svg";